import { useContext } from 'react'

import { StringsContext } from '@lib/strings-context'

import Icon from './icon'
import SimpleLink from './simple-link'

interface BackToProps {
  url: string
  title: string
}

const BackTo = ({ url, title }: BackToProps) => {
  const strings = useContext(StringsContext)

  return (
    <section className="container flex-wrap items-center gap-1 py-3 border-t border-gray">
      <SimpleLink
        href={url}
        className="inline-flex items-center gap-x-1 uppercase text-xs"
      >
        <Icon
          name="ChevronLeft"
          id={`back-to-${title}`}
          className="text-base"
        />

        <span>
          {strings.buttonBackTo} {title}
        </span>
      </SimpleLink>
    </section>
  )
}

export default BackTo
